module.exports = __webpack_public_path__ + "static/img/16.1ae632a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/16.png
// module id = pYi6
// module chunks = 0